import { Entities } from '@/entities/api/entities'

const entityConvert = (entity: Entities, isCategory: boolean = false) => {
	switch (entity) {
		case 'supplements':
			return isCategory ? 'Categoría Suplementos' : 'Suplementos'
		case 'plans_personalized':
			return isCategory
				? 'Categoría Planes Personalizados'
				: 'Planes Personalizados'
		case 'clothes':
			return isCategory ? 'Categoría Ropa' : 'Ropa'
		case 'accessories':
			return isCategory ? 'Categoría Accesorios' : 'Accesorios'
		default:
			return isCategory ? 'Categoría Desconocida' : 'Sin entidad'
	}
}

const entityToSpanishMap: Record<Entities, string> = {
	[Entities.SUPPLEMENTS]: 'suplementos',
	[Entities.PLANS_PERSONALIZED]: 'planes-personalizados',
	[Entities.CLOTHES]: 'ropa',
	[Entities.ACCESSORIES]: 'accesorios',
}

const spanishToEntityMap: Record<string, Entities> = Object.fromEntries(
	Object.entries(entityToSpanishMap).map(([key, value]) => [
		value,
		key as Entities,
	])
) as Record<string, Entities>

function entityToSpanish(entity: Entities): string {
	return entityToSpanishMap[entity] || ''
}

function spanishToEntity(spanish: string): Entities | undefined {
	return spanishToEntityMap[spanish.toLowerCase()]
}

export { entityConvert, entityToSpanish, spanishToEntity }
